import SectionSliderOwn from './SectionSliderOwn';
export default SectionSliderOwn;
